import { render, staticRenderFns } from "./GenericThumbGallery.vue?vue&type=template&id=ab83ac5c&"
import script from "./GenericThumbGallery.vue?vue&type=script&lang=js&"
export * from "./GenericThumbGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports